<div class="bank-details-nominee-tab">
  <div class="heading-tab">
    <h3 class="heading">Account Details: {{forWhom}}</h3>
  </div>

  <div class="tab-grid">
    <nz-form-item>
      <nz-form-label [nzSpan]="24"> Bank Account No</nz-form-label>
      <nz-form-control [nzSpan]="24">
        <input nz-input value="40078977300" [(ngModel)]="bankAccount" (ngModelChange)="OCRInputModelsHaveChanged()"/>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="24">Account Holder Name</nz-form-label>
      <nz-form-control [nzSpan]="24">
        <input nz-input value="Liam Hemsworth" [(ngModel)]="accountHolderName" (ngModelChange)="OCRInputModelsHaveChanged()"/>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="24">Method of Payout</nz-form-label>
      <nz-form-control [nzSpan]="24">
        <nz-select nzShowSearch  [ngModel]="'0'" style="width: 100%">
          <nz-option [nzLabel]="'Lump Sum'" [nzValue]="'0'"></nz-option>
          <nz-option [nzLabel]="'Regular'" [nzValue]="'1'"></nz-option>
          <nz-option [nzLabel]="'Annuity'" [nzValue]="'2'"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>

  <div class="heading-tab">
    <h3 class="heading">Bank Details: {{forWhom}}</h3>
    <button nz-button nzType="primary" (click)="modSearchBank=true;">Search Bank</button>
  </div>
  <div class="tab-grid">
    <nz-form-item>
      <nz-form-label [nzSpan]="24"> IFSC</nz-form-label>
      <nz-form-control [nzSpan]="24" [nzValidateStatus]="fakeValidationStatus">
        <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
          <input type="text" nz-input placeholder="IFSC Code" value="ICIC0006235"/>
        </nz-input-group>
        <ng-template #suffixIconButton>
          <button (click)="fetchFromIFSC(1200)" nz-button nzType="primary" class="d-b w-100-pc">
            <i nz-icon nzType="search"></i>
          </button>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="24">MICR</nz-form-label>
      <nz-form-control [nzSpan]="24">
        <input nz-input value="" [(ngModel)]="bank.micr"/>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="24">Name of Bank</nz-form-label>
      <nz-form-control [nzSpan]="24">
        <input nz-input [(ngModel)]="bank.bankName"/>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="24">Branch</nz-form-label>
      <nz-form-control [nzSpan]="24">
        <input nz-input value="" [(ngModel)]="bank.branchName"/>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="24">Address</nz-form-label>
      <nz-form-control [nzSpan]="24">
             <textarea
                     nz-input
                     placeholder="Address"
                     [nzAutosize]="{ minRows: 2, maxRows: 6 }"
                     [(ngModel)]="bank.address"
             ></textarea>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="24">City</nz-form-label>
      <nz-form-control [nzSpan]="24">
        <input nz-input value="" [(ngModel)]="bank.city"/>
      </nz-form-control>
    </nz-form-item>
  </div>

  <!-- CHEQUE UPLOAD AND VERIFICATION -->
  <div class="heading-tab">
    <h3 class="heading">Cheque/Passbook</h3>
  </div>
  <!-- Upload -->
  <div class="d-b" style="min-height: 120px">
    <nz-upload
            nzAction="https://jsonplaceholder.typicode.com/posts/"
            nzListType="picture-card"
            [(nzFileList)]="fileList"
            [nzShowButton]="fileList.length < 1"
            [nzShowUploadList]="showUploadList"
            [nzPreview]="handlePreview"
            (nzChange)="handleFileUploadChange($event)"
    >
      <i nz-icon nzType="plus"  nzTheme="outline"></i>
      <div class="ant-upload-text">Upload</div>
    </nz-upload>
    <nz-modal
            [nzVisible]="previewVisible"
            [nzContent]="modalContent"
            [nzFooter]="null"
            (nzOnCancel)="previewVisible = false"
    >
      <ng-template #modalContent>
        <img [src]="previewImage" [ngStyle]="{ width: '100%' }"/>
      </ng-template>
    </nz-modal>
  </div>

  <!-- OCR Verification -->
  <div *ngIf="OCRReady">
  <!-- <app-ocr-verifier [imageData]="OCRfileImage" [verificationArr]="OCRverificationData"></app-ocr-verifier> -->
  </div>

</div>


<!-- Search CUSTOMER -->
<nz-modal [(nzVisible)]="modSearchBank" nzTitle="Search Bank"
          (nzOnCancel)="modSearchBank=false" (nzOnOk)="modSearchBank=false;fetchFromIFSC(1)"
          nzOkText="Select" nzWidth="75%"
>
  <div *ngIf="modSearchBank">
    <div class="search-fields m-t-20">
      <!-- Customer Search -->
      <div>
        <div class="tab-grid">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Branch Name</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input value="MUMBAI FORT"/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Bank Name</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input value=""/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">City</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input value=""/>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">IFSC Code</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input value=""/>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div class="multisearch-grid">
        <div>
          <button nz-button nzType="primary">
            Search Banks
          </button>
        </div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="search-results m-t-20">
      <!-- Customer Search Results -->
      <div>
        <nz-table [nzData]="dataSet" [nzShowPagination]="true">
          <thead>
          <tr>
            <th></th>
            <th>Bank</th>
            <th>Branch</th>
            <th>Address</th>
            <th>IFSC</th>
          </tr>
          </thead>
          <tbody>

          <tr>
            <td>
              <nz-radio-group [(ngModel)]="selectedBranch">
                <label nz-radio nzValue="A"></label>
              </nz-radio-group>
            </td>
            <td>ICICI BANK LTD.</td>
            <td>MUMBAI - FORT</td>
            <td>NAVSARI BUILDING, 240, D.N.ROAD, FORT, MUMBAI. 400001</td>
            <td>ICIC0006235</td>
          </tr>
          <tr>
            <td>
              <nz-radio-group [(ngModel)]="selectedBranch">
                <label nz-radio nzValue="B"></label>
              </nz-radio-group>
            </td>
            <td>CITIBANK</td>
            <td>MUMBAI FORT</td>
            <td>1ST FLOOR, DXC COMPLEX, FORT, MUMBAI. 400001</td>
            <td>CITI0009911</td>
          </tr>
          <tr>
            <td>
              <nz-radio-group [(ngModel)]="selectedBranch">
                <label nz-radio nzValue="C"></label>
              </nz-radio-group>
            </td>
            <td>ICICI BANK LTD.</td>
            <td>MUMBAI - FORT</td>
            <td>NAVSARI BUILDING, 240, D.N.ROAD, FORT, MUMBAI. 400001</td>
            <td>ICIC0006235</td>
          </tr>

          </tbody>
        </nz-table>

      </div>
    </div>
  </div>
</nz-modal>
